/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text, TextProps, Title, TitleProps } from '@mantine/core';
import { FC, HTMLAttributes } from 'react';

export const ThemeTitle: FC<TitleProps> = ({ children, ...rest }) => (
  <Title sx={(theme) => ({ color: theme.colorScheme === 'dark' ? 'white' : 'black' })} {...rest}>
    {children}
  </Title>
);

type ThemeTextProps = TextProps & HTMLAttributes<HTMLDivElement>;

export const ThemeText: FC<ThemeTextProps> = ({ children, ...rest }) => (
  <Text sx={(theme) => ({ color: theme.colorScheme === 'dark' ? 'white' : 'black' })} {...rest}>
    {children}
  </Text>
);

type BlueTextProps = TextProps & HTMLAttributes<HTMLDivElement>;

export const BlueText: FC<BlueTextProps> = ({ children, ...rest }) => (
  <Text
    sx={(theme) => ({ color: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[4] })}
    {...rest}
  >
    {children}
  </Text>
);
